/**
 * Simple function to convert minutes to milliseconds
 * @param minutes 
 */
function convertMinutesToMilliseconds (minutes: number): number {

  return minutes * 60000

}

export default convertMinutesToMilliseconds
